<div class="edit-container">
    <h1 class="edit-title">Actualizează localizare</h1>
    <form class="edit-card__form" [formGroup]="form" (submit)="submitForm()">
        <div class="row">
            <div class="col-md-4">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Situație copil</mat-label>
                    <mat-select formControlName="situation_type" (selectionChange)="changeAddressType()">
                        <mat-option *ngFor="let item of situationType" [value]="item.id">
                            {{ item.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error
                        *ngIf="!form.controls['situation_type'].valid && form.controls['situation_type'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-md-4">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>De la</mat-label>
                    <input matInput [matDatepicker]="datefromPicker" formControlName="date_from" readonly
                        (focus)="datefromPicker.open()" />
                    <mat-hint>ZZ/LL/AAAA</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="datefromPicker"></mat-datepicker-toggle>
                    <mat-datepicker #datefromPicker></mat-datepicker>
                    <mat-error *ngIf="!form.controls['date_from'].valid && form.controls['date_from'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-md-4">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Până la</mat-label>
                    <input matInput [matDatepicker]="dateToPicker" formControlName="date_to" readonly
                        (focus)="dateToPicker.open()" />
                    <mat-hint>ZZ/LL/AAAA</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="dateToPicker"></mat-datepicker-toggle>
                    <mat-datepicker #dateToPicker></mat-datepicker>
                    <mat-error
                        *ngIf="form.controls['date_to'].hasError('required') && form.controls['date_to'].touched">
                        Câmp obligatoriu
                    </mat-error>
                    <mat-error
                        *ngIf="form.controls['date_to'].hasError('invalidDateRange') && form.controls['date_to'].touched">
                        Selectați o perioadă validă
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <!-- <div class="row">
            <div class="col-md-12">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Tip locație</mat-label>
                    <mat-select formControlName="address_type" (selectionChange)="changeAddressType()">
                        <mat-option *ngFor="let item of addressType" [value]="item.id">
                            {{ item.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="!form.controls['address_type'].valid && form.controls['address_type'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div> -->
        <ng-container *ngIf="this.form.get('situation_type')?.value === 1">
            <div class="row">
                <div class="col-md-12">
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label>Locație DGASPC</mat-label>
                        <mat-select formControlName="location_dgaspc">
                            <mat-option [value]="-1">-- Alegeți --</mat-option>
                            <mat-option *ngFor="let item of adreseCentre" [value]="item.id">{{
                                item.name }}</mat-option>
                        </mat-select>
                        <mat-error
                            *ngIf="!form.controls['location_dgaspc'].valid && form.controls['location_dgaspc'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="
            this.form.get('situation_type')?.value === 2 || 
            this.form.get('situation_type')?.value === 3 || 
            this.form.get('situation_type')?.value === 4
        ">
            <div class="row">
                <div class="col-md-4">
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label>Țară</mat-label>
                        <mat-select formControlName="tara_id" (openedChange)="onTariSelectClosed()"
                            (selectionChange)="onTariChange($event.value)">
                            <mat-form-field class="px-2 w-100 sticky-input">
                                <input matInput [formControl]="tariControl" (keydown)="$event.stopPropagation()"
                                    (click)="$event.stopPropagation()" />
                            </mat-form-field>

                            <mat-option *ngIf="filteredTari.length === 0" disabled>
                                <span>Nu s-au găsit rezultate</span>
                            </mat-option>

                            <mat-option [value]="-1">-- Alegeți --</mat-option>
                            <mat-option *ngFor="let tara of filteredTari" [value]="tara.id">
                                {{ tara.name }}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="!form.controls['tara_id'].valid && form.controls['tara_id'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label>Județ</mat-label>
                        <mat-select formControlName="judet_id" (openedChange)="onJudeteSelectClosed()"
                            (selectionChange)="onJudeteChange($event.value)">
                            <mat-form-field class="px-2 w-100 sticky-input">
                                <input matInput [formControl]="judeteControl" (keydown)="$event.stopPropagation()"
                                    (click)="$event.stopPropagation()" />
                            </mat-form-field>

                            <mat-option *ngIf="filteredJudete.length === 0" disabled>
                                <span>Nu s-au găsit rezultate</span>
                            </mat-option>

                            <mat-option [value]="-1">-- Alegeți --</mat-option>

                            <mat-option *ngFor="let judet of filteredJudete" [value]="judet.id">
                                {{ judet.name }}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="!form.controls['judet_id'].valid && form.controls['judet_id'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label>Localitate</mat-label>
                        <mat-select formControlName="localitate_id"
                            (selectionChange)="onLocalitatiChange($event.value)">
                            <mat-form-field class="px-2 w-100 sticky-input">
                                <input matInput [formControl]="localitatiControl" (keydown)="$event.stopPropagation()"
                                    (click)="$event.stopPropagation()" />
                            </mat-form-field>

                            <mat-option *ngIf="showLocalitatiMessage" disabled>
                                <span *ngIf="!localitatiControl.value || localitatiControl.value.length < 2">
                                    Vă rugăm să introduceți 2 caractere sau mai multe
                                </span>
                                <span
                                    *ngIf="isLocalitatiLoading && localitatiControl.value && localitatiControl.value.length >= 2">
                                    Se caută...
                                </span>
                                <span
                                    *ngIf="!isLocalitatiLoading && localitatiLoadComplete && localitati.length === 0 && localitatiControl.value && localitatiControl.value.length >= 2">
                                    Nu s-au găsit rezultate
                                </span>
                            </mat-option>

                            <mat-option [value]="-1">-- Alegeți --</mat-option>
                            <mat-option *ngFor="let localitate of localitati" [value]="localitate.id">
                                {{ localitate.name }}
                            </mat-option>
                        </mat-select>
                        <mat-error
                            *ngIf="!form.controls['localitate_id'].valid && form.controls['localitate_id'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <mat-form-field appearance="fill">
                        <mat-label>Sector</mat-label>
                        <mat-select formControlName="sector">
                            <mat-option [value]="0">-- Alegeți --</mat-option>
                            <mat-option [value]="1">Sector 1</mat-option>
                            <mat-option [value]="2">Sector 2</mat-option>
                            <mat-option [value]="3">Sector 3</mat-option>
                            <mat-option [value]="4">Sector 4</mat-option>
                            <mat-option [value]="5">Sector 5</mat-option>
                            <mat-option [value]="6">Sector 6</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label>Stradă</mat-label>
                        <mat-select formControlName="strada_id" (selectionChange)="onStraziChange($event.value)">
                            <mat-form-field class="px-2 w-100 sticky-input">
                                <input matInput [formControl]="straziControl" (keydown)="$event.stopPropagation()"
                                    (click)="$event.stopPropagation()" />
                            </mat-form-field>

                            <mat-option *ngIf="showStraziMessage" disabled>
                                <span *ngIf="!straziControl.value || straziControl.value.length < 2">
                                    Vă rugăm să introduceți 2 caractere sau mai multe
                                </span>
                                <span *ngIf="isStraziLoading && straziControl.value && straziControl.value.length >= 2">
                                    Se caută...
                                </span>
                                <span
                                    *ngIf="!isStraziLoading && straziLoadComplete && strazi.length === 0 && straziControl.value && straziControl.value.length >= 2">
                                    Nu s-au găsit rezultate
                                </span>
                            </mat-option>

                            <mat-option [value]="-1">-- Alegeți --</mat-option>
                            <mat-option *ngFor="let strada of strazi" [value]="strada.id">
                                {{ strada.name }}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="!form.controls['strada_id'].valid && form.controls['strada_id'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <mat-form-field appearance="fill">
                        <mat-label>Număr</mat-label>
                        <input type="text" matInput formControlName="numar" />
                    </mat-form-field>
                </div>
            </div>

            <div class="row">
                <div class="col-md-2">
                    <mat-form-field appearance="fill">
                        <mat-label>Bloc</mat-label>
                        <input type="text" matInput formControlName="bloc" />
                    </mat-form-field>
                </div>
                <div class="col-md-2">
                    <mat-form-field appearance="fill">
                        <mat-label>Etaj</mat-label>
                        <input type="text" matInput formControlName="etaj" />
                    </mat-form-field>
                </div>
                <div class="col-md-2">
                    <mat-form-field appearance="fill">
                        <mat-label>Scară</mat-label>
                        <input type="text" matInput formControlName="scara" />
                    </mat-form-field>
                </div>
                <div class="col-md-3">
                    <mat-form-field appearance="fill">
                        <mat-label>Apartament</mat-label>
                        <input type="text" matInput formControlName="apartament" />
                    </mat-form-field>
                </div>
                <div class="col-md-3">
                    <mat-form-field appearance="fill">
                        <mat-label>Cod Poștal</mat-label>
                        <input type="text" matInput formControlName="cod_postal" />
                    </mat-form-field>
                </div>
            </div>
        </ng-container>

        <div class="row">
            <div class="col-md-12">
                <mat-form-field appearance="fill">
                    <mat-label>Observații</mat-label>
                    <textarea matInput formControlName="observatii" name="observatii"></textarea>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col d-flex justify-content-between">
                <button class="buttons" type="button" mat-stroked-button (click)="closeDialog()">
                    {{ helper.dialogConfig.buttonLabels.close }}
                </button>
                <button class="buttons" type="submit" mat-flat-button color="primary" [disabled]="form.invalid">
                    {{ helper.dialogConfig.buttonLabels.save }}
                </button>
            </div>
        </div>
    </form>
    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>